import { dapiFetch } from "@origin-digital/daxi";
import { config } from "src/config";

export interface IResetPasswordLinkResponse {
  resetPasswordUrl: string;
}

export const getResetPasswordLink = async (): Promise<string> => {
  const response = await dapiFetch<IResetPasswordLinkResponse>(
    "/auth/api/v1/reset-password-link",
    { authorization: "jwt", method: "get" }
  );
  if (response && response.status === 201 && response.data) {
    return response.data.resetPasswordUrl;
  } else {
    return Promise.reject(
      "[getResetPasswordLink] Unable to get password reset URL"
    );
  }
};

export const getSurveyOptOutStatus = async (): Promise<boolean> => {
  const response = await dapiFetch<{ isSurveyOptOut: boolean }>(
    config.internetApi.accountDetails,
    { authorization: "jwt", method: "get" }
  );
  if (response && response.status === 200 && response.data) {
    return response.data.isSurveyOptOut;
  } else {
    return Promise.reject("[getIsSurveyOptOut] Unable to get opt-out status");
  }
};

export const updateSurveyOptOutStatus = async (
  isSurveyOptOut: boolean
): Promise<void> => {
  try {
    const response = await dapiFetch<void>(
      `${config.internetApi.accountDetails}/opt-out`,
      {
        authorization: "jwt",
        method: "put",
        body: { isSurveyOptOut },
        headers: { "Content-Type": "application/json" },
      }
    );
    if (!response || response.status !== 200) {
      return Promise.reject(
        "[updateSurveyOptOutStatus] Failed to update opt-out status"
      );
    }
  } catch (error) {
    return Promise.reject(
      `[updateSurveyOptOutStatus] Error: ${(error as Error).message}`
    );
  }
};
